import React, {useEffect, useState} from "react";
import I18n from 'i18n.js.erb'
import { parseBigInteger, parseExpansionNameAndEdition } from "../../utils/utils";

const SubBannerExpansions = ({parent_expansion, sub_expansions, game_name, handleNavigation,hasTranslations,handleHideSubExpansions}) => {


  return (
    <React.Fragment>
      <div className="row justify-content-end">

        <div className="col-lg-2 pr-0 show-on-desktop">
          <div className="year-txt d-flex justify-content-end text-space text-weight-500 text-dark-gray w-100 position-relative"></div>
          <div
            className="chronology-marker position-relative d-flex justify-content-center align-items-center w-25">
          </div>
        </div>

        <div className="col-xs-11 col-lg-10 pl-26px">

          <div className="collapse collapse-item d-flex justify-content-end m-1">
            <div className="col-xs-12 col-lg-10 p-0">

              <div className="row w-100 m-0">

                {sub_expansions.map((sub_expansion, i) => {
                  return (
                    <React.Fragment key={sub_expansion.id + '_' + sub_expansion.language }>
                      <div className="col-12 p-0">
                        {
                          i === 0 &&
                          <i className="fas fa-angle-up ml-2 mt-2 enable-filters-expansions-icon" style={{ cursor: "pointer" }}
                             onClick={(e) => handleHideSubExpansions(e, parent_expansion)}/>
                        }
                      </div>

                      <div id={"sub_expansion_" + sub_expansion.id + '_' + sub_expansion.language}
                           className=" align-items-center d-flex text-center mt-3 bg-gradient-card--subexpansion w-100 border-aiG-light-gray-imp"
                           style={{minHeight: "60px", cursor: "pointer"}}
                           onClick={(e) => handleNavigation(e, sub_expansion)}>

                        <div className="col-xs-7 col-lg-9 mt-10px mb-10px ">
                            {/*Name expansion*/}
                          <div className="col-xs-12 col-lg-5 p-0">
                            <div
                              className="
                              expansion__expansionName--size
                              col-xs-12 col-lg-10
                              text-night-blue text-space text-align-left-imp
                              pt-10px pb-10px pl-0 pr-0
                              ">

                              <div className="d-flex">
                                {
                                  hasTranslations &&
                                    <img src={window.location.origin + `/images/flags/${sub_expansion.language}.png`}
                                         style={{ maxHeight: "20px", marginRight: "15px",marginTop: "5px"}} alt=""/>
                                }

                                <p className="mb-0">
                                  { parseExpansionNameAndEdition(sub_expansion.name, sub_expansion.edition, game_name) }
                                </p>
                              </div>
                              {
                                sub_expansion.en_name &&
                                <p className="mb-0">{sub_expansion.en_name}</p>
                              }
                            </div>
                          </div>


                          {/*img expansion*/}
                          <div className="col-xs-12 col-lg-7 p-0 ">
                            <div className="row mb-10px mt-10px">
                              {
                                sub_expansion.icons_urls && sub_expansion.icons_urls.length > 0 ?
                                  sub_expansion.icons_urls.map((url, i) => {
                                    return (
                                      <div key={url + "_" + i}
                                           className="col-xs-2 col-lg-1 ml-2">
                                        <img
                                          className="expansion__symbol--size"
                                          src={url}
                                        />
                                      </div>
                                    );
                                  })
                                  :
                                  <div className="col-2 ml-2">
                                    <img
                                      className="expansion__symbol--size"
                                      src={sub_expansion.icon_url}
                                    />
                                  </div>
                              }
                            </div>
                          </div>
                        </div>


                        {/*/!*counters*!/*/}
                        <div className="col-xs-5 col-lg-3 bg-gradient-card align-items-center p-0 expansion__expansionName--size text-night-blue d-flex right-angle-radius">

                          <div className="col-12">
                            <p
                              className=" d-flex justify-content-end text-center text-space text--white-space-break mb-0">
                              {I18n.t('js.expansionsPage.aigCard')}: {parseBigInteger(sub_expansion.graded_cards_population)}
                            </p>
                            <p className="d-flex justify-content-end text-space text-center ">
                              {I18n.t('js.expansionsPage.myCollection')}: {sub_expansion.blueprint_images_on_my_collection + "/" + sub_expansion.count_blueprint_images}
                            </p>
                          </div>
                        </div>

                      </div>
                    </React.Fragment>
                  )
                })
                }
              </div>
            </div>

          </div>
        </div>


      </div>
    </React.Fragment>

  );
};

export default SubBannerExpansions;
